import React from 'react';
import logo from './assets/Feed-beef.jpg';
import icon from './assets/TasteIcon.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <img src={logo} style={{width:'60%', height: "98%", opacity: 0.25, position: 'absolute', zIndex: 0 }} className="App-logo" alt="logo" />
      <header className="App-header" >
        <h2 style={{zIndex: 1 }}>Taste Privacy Policy</h2>
        <img src={icon} style={{ width:96, height:96, zIndex: 1, borderRadius: '10px', marginTop:25, marginBottom: 5 }} className="App-icon" alt="icon" />
        <p style={{ width:'47%', textAlign: 'justify', zIndex: 1, fontSize:22 }}>
          &nbsp;&nbsp;&nbsp;&nbsp;At Taste, we recognize that your data is important to you. We guard it with our best intentions.
          As a full disclosure, we store information in order to be able to be in contace with our clients for clarification 
          and communication purposes. We store instagram usernames, Facebook IDs & Instagram IDs in order to ask the Facebook 
          Graph API to return images of your Instagram Stories so that we can verify that you have posted pictures 
          in restaurants that satisfy our terms of agreement with both the influencers and the restaurants with whom we work.
          </p>
          <p style={{ width:'47%', textAlign: 'justify', zIndex: 1, fontSize:22 }}> 
          &nbsp;&nbsp;&nbsp;&nbsp;Other than this, we do not store your Instagram story 
          information for more than 60 days, they're deleted as soon as we generate a report for the business in which you've 
          entered and posted a picture in, and our brick & mortar clients are satisfied with the full disclosure that we have given them. If you would like us to store 
          your photos for longer than this, you can reach out to us through the app & we will help you with this procedure.
        </p>
        <h6 style={{margin: '5%'}}>Please Contact Us @: &nbsp;&nbsp; admin@tasteinfluence.com</h6>
      </header>
    </div>
  );
}

export default App;
